import { create } from 'zustand';

import { type UserAccount } from '@root/features/authentication/types/userAccount';

/**
 * Key under which access token is stored in local storage
 * @type {string}
 */
export const HTTP_ONLY_COOKIE_TOKEN_KEY = '_hocid';

/**
 * Key for the non-HTTP-only marker cookie to detect authentication state
 * @type {string}
 */
export const AUTH_MARKER_COOKIE_KEY = '_hocid_marker';

/**
 * SessionStore
 * @export
 */
export const useSessionStore = create<SessionStore>()((set) => ({
	/** User data */
	account: null,
	setAccount: (account: UserAccount | null) => set({ account }),

	/** Authentication status */
	isAuthenticated: false,
	setIsAuthenticated: (isAuthenticated: boolean) => set({ isAuthenticated }),
}));

/**
 * Session store type
 * @export
 */
export type SessionStore = {
	/** User session */
	account: UserAccount | null;
	setAccount: (account: UserAccount | null) => void;

	/** Authentication status */
	isAuthenticated: boolean;
	setIsAuthenticated: (isAuthenticated: boolean) => void;
};
